import { useQuery } from '@tanstack/react-query';
import { fetchParkingContract } from '../../api/parking-contract.ts';
import type { ParkingContract } from '../../models/parking-contract.ts';

export default function useParkingContract(
  partnerId: string,
  id: string,
  enabled: boolean = true,
) {
  const result = useQuery<{ data: ParkingContract }>({
    queryKey: ['partner', partnerId, 'parkingContract', id],
    queryFn: () => fetchParkingContract(partnerId, id),
    enabled,
  });

  const { data, ...rest } = result;
  return { parkingContract: data?.data, ...rest };
}
